import { render } from "./AskConfirmMail.vue?vue&type=template&id=dc6cbdec&scoped=true"
import script from "./AskConfirmMail.vue?vue&type=script&lang=js"
export * from "./AskConfirmMail.vue?vue&type=script&lang=js"

import "./AskConfirmMail.vue?vue&type=style&index=0&id=dc6cbdec&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc6cbdec"]])

export default __exports__